<template>
    <div
        :class="[
            'acell',
            cellType,
            {
                filled: cellData.items.length > 0,
                tooltiperror: !cellData.valid,
            },
        ]"
        @click="onCellClick($event, cellType, locationId)"
        @mouseenter="onCellHover($event, cellType, locationId)"
    >
        <AssignmentErrorTooltip
            v-show="!cellData.valid"
            tooltip-class="tooltiptext"
            :errors="cellData.invalidMessages"
        />
        <div class="acell-wrap">
            <div
                v-for="item in cellData.items"
                :key="item.id"
                :class="[
                    'acell-item-wrapper',
                    { overloaded: item.overloaded },
                    { 'not-editable': isNotEditable(item.type, item.id) },
                ]"
            >
                <div
                    :class="[
                        'acell-item',
                        {
                            'group-tag': item.isGroup && !item.overloaded,
                        },
                    ]"
                    :title="item.tooltipTitle"
                >
                    <div class="acell-item-text">{{ item.title }}</div>
                    <button
                        class="close-button"
                        @click.stop="
                            isNotEditable(item.type, item.id)
                                ? ''
                                : onCellItemClick(locationId, cellType, item.id)
                        "
                    >
                        <i
                            :title="
                                isNotEditable(item.type, item.id)
                                    ? $t('assignments.cantRemoveSuperUser')
                                    : item.tooltipTitle
                            "
                            class="icon-close"
                        ></i>
                    </button>
                </div>
            </div>
        </div>
        <span v-if="cellData.items.length === 0" class="acell-placeholder">
            {{ $t('assignments.addUser') }}
        </span>
    </div>
</template>

<script type="text/babel">
import AssignmentErrorTooltip from './AssignmentErrorTooltip';
import mappingState from '../common/mappingState';
import { USER_TYPES } from '../../constants';

export default {
    components: {
        AssignmentErrorTooltip,
    },

    mixins: [mappingState],

    props: {
        cellType: {
            type: String,
            required: true,
        },

        locationId: {
            type: Number,
            required: true,
        },

        cellData: {
            type: Object,
            required: true,
        },

        onCellClick: {
            type: Function,
            required: true,
        },

        onCellHover: {
            type: Function,
            required: true,
        },

        onCellItemClick: {
            type: Function,
            required: true,
        },
    },

    methods: {
        isNotEditable(userType, userId) {
            return userId !== this.userId && userType === USER_TYPES.SUPER_USER;
        },
    },
};
</script>
